{
  "header": {
    "appName": "Bennie",
    "workspaces": "Workspaces",
    "projects": "Projects",
    "analytics": "Analytics",
    "reggie": "Test Ground",
    "settings": "Settings",
    "signOut": "Sign out",
    "home": "Home",
    "ariaLogo": "Kyronyx",
    "tooltipAccount": "Account",
    "userPlaceholder": "User",
    "notSignedIn": "Not signed in",
    "signedIn": "Signed in",
    "administrator": "Administrator",
    "signIn": "Sign in",
    "profile": "Profile",
    "models": "Models",
    "dashboard": "Dashboard"
  },
  "rail": {
    "navLabel": "Main navigation",
    "modelLinksLabel": "Model sections",
    "trailLabel": "Breadcrumb"
  },
  "breadcrumb": {
    "workspaces": "Workspaces",
    "workspace": "Workspace",
    "plan": "Plan",
    "report": "Report",
    "files": "Files"
  },
  "tabs": {
    "data": "Data",
    "plan": "Plan",
    "report": "Report",
    "settings": "Settings"
  },
  "userMenu": {
    "settings": "Settings",
    "signOut": "Sign out"
  },
  "serviceSelection": {
    "comingSoonAppend": "{{description}} — Not available",
    "continue": "Continue",
    "selectServiceType": "Select Service Type",
    "genericTaskTitle": "Generic task",
    "genericTaskDescription": "Skip service selection. Upload documents directly and generate a custom report.",
    "availabilityWarning": "Service availability could not be verified. All categories are shown — some may not have curated knowledge loaded.",
    "serviceTypes": {
      "validation": "Validation",
      "auditing": "Auditing",
      "development": "Development"
    }
  }
}
